module.exports = __webpack_public_path__ + "img/des-main-background-920.5267dd38.jpeg";